import { SET_TEAM_MEMBERS, SET_TEAM_MEMBER } from "../actionTypes"

const initialState = {
  teamMembersObject: {},
  teamMembers: {},
  teamMember: {}
}

const teamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEAM_MEMBERS:
      return {
        ...state,
        teamMembers: action.teamMembers,
        // teamMembersObject: action.teamMembers
      }
    case SET_TEAM_MEMBER:
      return {
        ...state,
        teamMember: action.teamMember,
      }
    default:
      return state
  }
}

export default teamMembersReducer